import { CookieEditIcon } from './CookieEditIcon';

/**
 * author: Colton Wiscombe
 * id E36B77B1-913A-45CC-A23B-02EA12161352
 * name cookie-edit
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cookie-edit.svg
 * tags
 * - Food / Drink 
 * - Edit / Modify 
 */
export const BiscuitEditIcon = CookieEditIcon;
export default BiscuitEditIcon